/* ============
 * Getters for the followUps module
 * ============
 *
 * The getters that are available on the
 * followUps module.
 */
import { clone } from '@/utils/object';

const getFollowUp = state => clone(state.followUp);
const getFollowUpList = state => clone(state.followUpList);
const getLoading = state => clone(state.loading);
const getFollowUpSymptoms = state => clone(state.followUpSymptoms);
const getFollowUpResolvedNotes = state => clone(state.resolvedNotes);
const getTotalCount = state => clone(state.totalCount);
const getResolvedAlertId = state => state.resolvedAlertId;
const getIsResolutionLoading = state => state.isResolutionLoading;

export default {
  getFollowUp,
  getFollowUpList,
  getLoading,
  getFollowUpSymptoms,
  getFollowUpResolvedNotes,
  getTotalCount,
  getResolvedAlertId,
  getIsResolutionLoading
};
